<template>
    <v-card>
        <v-form
            ref="comissionreportForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-card-title>Reset Customer Import Job</v-card-title>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-file-input
                                :disabled="isLoading"
                                :rules="[requiredRule]"
                                accept=".csv"
                                label="Customer Import CSV"
                                placeholder="Select csv file"
                                ref="importdoc"
                                v-model="importDoc"
                            >
                            </v-file-input>
                        </v-col>
                    </v-row>

                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Close</v-btn
                        >
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="importCustomers"
                            class="text-none"
                            color="secondary darken-1"
                            text
                            >Reset</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
//import dateToString from "../../helpers/dateToString"
import CustomerImportJob from "../../models/CustomerImportJob.model";
export default {
    props: {
        entityId: Number,
    },
    data() {
        return {
            isValid: null,
            isLoading: false,
            isSaving: false,
            changesList: [],
            notifyShow: false,
            notifyMessage: "",
            notifyColor: "",
            signedBy: null,
            company: null,
            representative: null,
            subscription: null,
            debitOrderDate: null,
            importDoc: null,
            sureReps: [],
            representatives: [],
            subscriptions: [],
            debitOrderDates: [],
            companies: [],
            requiredRule: (v) => !!v || "required",
            requiredRuleNum: (v) => !!v || v === 0 || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            showChangeList: false,
        };
    },

    created: async function () {},

    methods: {
        emitCloseForm() {
            this.$emit("close");
        },

        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },

        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },

        validateForm() {
            this.isValid = this.$refs.comissionreportForm.validate();
            return this.isValid;
        },

        importCustomers() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var model = new CustomerImportJob();
                model.id = this.entityId;

                var formdata = new FormData();
                formdata.append("ImportDoc", this.importDoc);
                formdata.append("Model", JSON.stringify(model));

                this.$store
                    .dispatch("customerimportjobs/reset", formdata)
                    .then(() => {
                        this.closeForm();
                    })
                    .catch((error) => {
                        // Show error message
                        this.notify(
                            error.message || "An error occurred",
                            "error"
                        );
                    })
                    .finally(() => {
                        // Import done, stop loading indicators
                        this.importDone();
                    });
            }
        },

        importDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
    },
};
</script>
